import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../lib/redux/hooks";
import { GetFileByIdToZip, resetGetFileByIdStatus, resetGetFileByIdToZipResponses, resetGetFileByIdToZipStatus, setGetFileByIdToZipRequest } from "../../../objectStorage/slice";
import { downloadZip } from "../../../objectStorage/utils";
import { DownloadIcon } from "../../../ui/icons/DownloadIcon";
import { MagnifyingIcon } from "../../../ui/icons/magnifying";
import { ButtonComponent } from "../../../ui/molecules/button/newButton";
import { Calendar } from "../../../ui/molecules/calendar";
import { MadfarmInput } from "../../../ui/molecules/input/newInput";
import { MadfarmStaticSelect } from "../../../ui/molecules/select/newSelect/static";
import { PopupForm } from "../../../ui/organisms/popupForm";
import { formatterDate, OptionType, yearOptions } from "../../../utils";
import { GetAllDepartureProtocolAttachments, GetAllDepartureProtocolObjects, GetAllDepartureProtocols, resetGetAllDepartureProtocolAttachmentsStatus, resetGetAllDepartureProtocolObjectsStatus, resetGetAllDepartureProtocolsStatus, resetGetAllPPFiltersDocuments, setGetAllPPFilterAttachmentId, setGetAllPPFilterClient, setGetAllPPFilterObjectId, setGetAllPPFilterObjectSpec, setGetAllPPFilterProtocolDay, setGetAllPPFilterYear } from "../../protocol/departure/slice";
import { DetailsPopup } from "../detailsPopup";
import { setDepartureResponseSelected } from "../slice";

interface Props {
    selectedCustomer: string
}

export function DepartureDocuments(props: Props) {
    const navigate = useNavigate()

    const dispatch = useAppDispatch()
    const departureProtocolState = useAppSelector(state => state.departureProtocol)
    const objectStorageState = useAppSelector(state => state.objectStorage)
    const [objects, setObjects] = useState<OptionType[]>([])
    const [attachments, setAttachments] = useState<OptionType[]>([])
    const [fileName, setFileName] = useState<string | null>(null)
    const [protocolName, setProtocolName] = useState<string | undefined>(undefined)
    const [showPopupDeparture, setShowPopupDeparture] = useState<boolean>(false)

    const handleOnDownload = (fileIds: string[]) => {
        dispatch(resetGetFileByIdToZipResponses())
        dispatch(setGetFileByIdToZipRequest(fileIds))
    }

    useEffect(() => {
        if (objectStorageState.getFileObjectByIdStatus === 'successfully') {
            // dispatch(setUpdatedFile(objectStorageState.getFileObjectByIdResponse))
        }

    }, [objectStorageState.getFileObjectByIdStatus])

    useEffect(() => {
        // const currentYear = new Date().getFullYear().toString()
        // dispatch(setGetAllPPFilterYear(currentYear))
        dispatch(setGetAllPPFilterClient(props.selectedCustomer))
        dispatch(GetAllDepartureProtocolObjects())
        dispatch(GetAllDepartureProtocolAttachments({
            itemsPerPage: 0,
            page: 0
        }))
    }, [])

    useEffect(() => {
        if (departureProtocolState.getAllDepartureProtocolFilters.client)
            dispatch(GetAllDepartureProtocols(departureProtocolState.getAllDepartureProtocolFilters))
    }, [departureProtocolState.getAllDepartureProtocolFilters.client])

    useEffect(() => {
        if (departureProtocolState.getAllDepartureProtocolsStatus === 'successfully') {
            dispatch(resetGetAllDepartureProtocolsStatus())
        }
    }, [departureProtocolState.getAllDepartureProtocolsStatus])

    useEffect(() => {
        if (departureProtocolState.getAllDepartureProtocolObjectsStatus === 'successfully' &&
            departureProtocolState.getAllDepartureProtocolObjectsResponse !== undefined
        ) {
            dispatch(resetGetAllDepartureProtocolObjectsStatus())
            const data = departureProtocolState.getAllDepartureProtocolObjectsResponse
            const newObjects: OptionType[] = data.map(d => {
                return { value: d.id, label: `${d.description} [${d.coding}]` } as OptionType
            })
            setObjects(newObjects)
        }
    }, [departureProtocolState.getAllDepartureProtocolObjectsStatus])

    useEffect(() => {
        if (departureProtocolState.getAllDepartureProtocolAttachmentsStatus === 'successfully' &&
            departureProtocolState.getAllDepartureProtocolAttachmentsResponse !== undefined
        ) {
            dispatch(resetGetAllDepartureProtocolAttachmentsStatus())
            const data = departureProtocolState.getAllDepartureProtocolAttachmentsResponse
            const newAtts: OptionType[] = data.data.map(d => {
                return { value: d.id, label: `${d.description} [${d.coding}]` } as OptionType
            })
            setAttachments(newAtts)
        }
    }, [departureProtocolState.getAllDepartureProtocolAttachmentsStatus])

    useEffect(() => {
        if (objectStorageState.getFileByIdStatus === 'successfully') {
            dispatch(resetGetFileByIdStatus())
            const base64Data = objectStorageState.getFileByIdResponse?.base64;
            if (base64Data && base64Data !== '') {
                const byteCharacters = atob(base64Data);
                const byteNumbers = Uint8Array.from(byteCharacters, char => char.charCodeAt(0));
                const blob = new Blob([byteNumbers], { type: 'application/pdf' });
                const url = URL.createObjectURL(blob);

                // Apri una finestra popup con un titolo personalizzato
                const newWindow = window.open('', '_blank', 'width=800,height=600');
                if (newWindow) {
                    newWindow.document.title = fileName!;
                    const iframe = newWindow.document.createElement('iframe');
                    iframe.style.width = '100%';
                    iframe.style.height = '100%';
                    iframe.src = url;
                    newWindow.document.body.appendChild(iframe);
                }
            }
        }
    }, [objectStorageState.getFileByIdStatus]);

    useEffect(() => {
        if (objectStorageState.getFileByIdToZipRequest.length < 1) {
            if (objectStorageState.getFileByIdToZipResponses.length > 0) {
                const download = async () => await downloadZip(objectStorageState.getFileByIdToZipResponses, protocolName)
                download()
                    .finally(() => dispatch(resetGetFileByIdToZipResponses()))
            }
            return
        }

        // [request.length > 0]
        const fileId = objectStorageState.getFileByIdToZipRequest[0]
        dispatch(GetFileByIdToZip(fileId))
    }, [objectStorageState.getFileByIdToZipRequest])

    useEffect(() => {
        if (objectStorageState.getFileByIdToZipStatus === 'successfully') {
            dispatch(resetGetFileByIdToZipStatus())
            if (objectStorageState.getFileByIdToZipRequest.length > 0) {
                dispatch(setGetFileByIdToZipRequest(objectStorageState.getFileByIdToZipRequest.slice(1)))
            }
        }
    }, [objectStorageState.getFileByIdToZipStatus])

    const handleAtts = (subs: string[] | null | undefined) => {
        if (!subs || subs.length < 1)
            return '';
        return subs.slice(0, -1)
            .map(s => `${s} - `)
            + subs[subs.length - 1]
    }

    return (
        <div className="flex flex-col gap-4 p-6 min-w-0 max-w-full overflow-x-hidden">
            <div className="w-full max-w-full min-w-0">
                <div className="w-full min-w-0 flex flex-col xl:flex-row gap-2 xl:items-center">
                    <div className="flex-1 min-w-0 grid grid-cols-1 md:grid-cols-2 xl:grid-cols-5 gap-2">
                        <Calendar
                            placeholder="Data"
                            selected={departureProtocolState.getAllDepartureProtocolFilters.protocolDate}
                            onChange={(date) => dispatch(setGetAllPPFilterProtocolDay(date))}
                        />
                        <MadfarmStaticSelect
                            noOptionsMessage="Nessun risultato trovato"
                            placeholder={'Anno'}
                            value={departureProtocolState.getAllDepartureProtocolFilters.year}
                            options={yearOptions}
                            onChange={(value) => {
                                //@ts-ignore
                                const newValue = value !== null ? value.value : null;
                                dispatch(setGetAllPPFilterYear(newValue))
                            }}

                        />
                        <MadfarmStaticSelect
                            noOptionsMessage="Nessun risultato trovato"
                            value={departureProtocolState.getAllDepartureProtocolFilters.objectId}
                            placeholder={'Seleziona Oggetto'}
                            options={objects}
                            onChange={(value) => {
                                //@ts-ignore
                                const newValue = value !== null ? value.value : null;
                                dispatch(setGetAllPPFilterObjectId(newValue))
                            }}
                        />
                        <MadfarmInput
                            placeholder="Specifiche"
                            onChangeText={(text) => { dispatch(setGetAllPPFilterObjectSpec(text)) }}
                        />
                        <MadfarmStaticSelect
                            noOptionsMessage="Nessun allegato trovato"
                            value={departureProtocolState.getAllDepartureProtocolFilters.attachmentId}
                            placeholder={'Seleziona Allegato'}
                            options={attachments}
                            onChange={(value) => {
                                //@ts-ignore
                                const newValue = value !== null ? value.value : null;
                                dispatch(setGetAllPPFilterAttachmentId(newValue))
                            }}

                        />
                    </div>
                    <div className="flex flex-row gap-2 items-center justify-end shrink-0">
                        <ButtonComponent
                            size={"lg"}
                            iconPosition={"off"}
                            variant={"outline"}
                            label="Pulisci"
                            color={"gray"}
                            onClick={() => {
                                dispatch(resetGetAllPPFiltersDocuments())
                                dispatch(setGetAllPPFilterClient(props.selectedCustomer))
                            }}
                        />
                        <ButtonComponent
                            size={"lg"}
                            iconPosition={"off"}
                            variant={"outline"}
                            label="Cerca"
                            color={"orange"}
                            onClick={() => dispatch(GetAllDepartureProtocols(departureProtocolState.getAllDepartureProtocolFilters))}
                        />
                    </div>
                </div>
            </div>
            <div className="w-full max-w-full py-6 min-w-0">
                <div className="w-full overflow-x-auto rounded-xl border border-neutral-200 shadow-sm">
                    <table className="w-full border-collapse text-sm">
                        <thead>
                            <tr className="bg-brandPrimary-600 text-white uppercase text-xs tracking-wide h-[52px]">
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap rounded-tl-xl">Azione</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Sede</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Data</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Anno</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Numero</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Nome Cliente</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Oggetto</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Oggetto Extra</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Allegati</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Protocollo Principale</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Funzionario</th>
                                <th className="px-3 py-3 text-center font-semibold whitespace-nowrap rounded-tr-xl w-[80px]"></th>
                            </tr>
                        </thead>
                        <tbody>
                            {(departureProtocolState.getAllDepartureProtocolsResponse?.data ?? []).length === 0 ? (
                                <tr>
                                    <td colSpan={12} className="px-3 py-3 text-center text-neutral-500 bg-white">
                                        Nessun protocollo trovato
                                    </td>
                                </tr>
                            ) : (
                                (departureProtocolState.getAllDepartureProtocolsResponse?.data ?? []).map((protocol, index) =>
                                    <tr
                                        key={index}
                                        className={`text-left border-b border-neutral-200 transition-colors duration-150 hover:bg-brandPrimary-50 ${index % 2 === 0 ? 'bg-white' : 'bg-neutral-50'}`}
                                    >
                                        <td className="px-3 py-2 w-[60px]">
                                            <div className="flex items-center justify-center gap-2">
                                                <button
                                                    className="relative group p-1 rounded hover:bg-neutral-100 transition-colors"
                                                    onClick={() => {
                                                        dispatch(setDepartureResponseSelected(protocol))
                                                        setShowPopupDeparture(true)
                                                    }}>
                                                    <MagnifyingIcon color={"Orange"} size={18} />
                                                </button>

                                                {
                                                    Array.isArray(protocol.attachmentFile) && protocol.attachmentFile.length > 0 ? (
                                                        <button
                                                            className="relative group p-1 rounded hover:bg-neutral-100 transition-colors"
                                                            onClick={() => {
                                                                setProtocolName(`${protocol.headQuarter} P${protocol.protocolNumber}`)
                                                                handleOnDownload([
                                                                    ...protocol.attachmentFile
                                                                        .map(attF => attF.fileInfo?.fileId)
                                                                        .filter((fileId): fileId is string => Boolean(fileId)),
                                                                    ...(protocol.fileId ? [protocol.fileId] : [])
                                                                ])
                                                            }}>
                                                            <DownloadIcon size="30" color={"Orange"} />
                                                        </button>
                                                    ) : null
                                                }
                                            </div>
                                        </td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{protocol.headQuarter}</td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{formatterDate(protocol.protocolDate)}</td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{protocol.year}</td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{protocol.protocolNumber}</td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{protocol.receiver}</td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{`${protocol.departureObject.description} [${protocol.departureObject.coding}]`}</td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{protocol.objectSpec || '-'}</td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{Array.isArray(protocol.departureAttachments) && protocol.departureAttachments.length > 0 ?
                                            handleAtts(protocol.departureAttachments.map(att => `[${att.coding}]`)) : '-'}</td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{protocol.linkExistingProtocol || '-'}</td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">{`${protocol.user.name} ${protocol.user.surname}`}</td>
                                        <td className="px-3 py-2"></td>
                                    </tr>
                                )
                            )}
                        </tbody>
                    </table>
                </div>
                {/* <Pagination
                        numbResults={usersState.getUsersResponse ? usersState.getUsersResponse?.total : 0}
                        detailsResults={'utenti'}
                        pages={usersState.getUsersResponse?.totalPage || 1}
                        currentPage={usersState.filters.page} setPage={(page) => dispatch(setFindAllUsersFiltersPage(page))}
                    /> */}
                {
                    showPopupDeparture && (
                        <PopupForm title="Dettagli Protocollo" headerGreen={true} close={() => {
                            setShowPopupDeparture(false)
                        }}>
                            <DetailsPopup type="departure" close={() => {
                                setShowPopupDeparture(false)
                            }} />
                        </PopupForm>
                    )
                }
            </div>
        </div>
    )
}